import { Badge, Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { TextGray } from "components/Atomos/Texts/TextGray";
import { UsoSolo } from "store/modules/consultaprevia/types";

export const UsosSoloLista = ({ usosSolo }: { usosSolo: UsoSolo[] }) => {
  const bgColor = useColorModeValue("gray.100", "gray.800");

  if (!usosSolo?.length) {
    return (
      <TextGray fontSize="sm">
        Nenhuma categoria de uso do solo alcança este ponto.
      </TextGray>
    );
  }

  return (
    <Box>
      {usosSolo.map((uso) => (
        <Box key={uso.id} bgColor={bgColor} borderRadius="md" p="3" mb="2">
          <Flex justifyContent="space-between" alignItems="center" gap="2">
            <Text fontSize="sm" fontWeight="medium">
              {uso.nome}
            </Text>
            {/* Categoria que veda atividade econômica muda o que o cidadão
                pode fazer no lote — precisa ficar visível, não implícita. */}
            {uso.proibeAtividadesEconomicas && (
              <Badge colorScheme="red" fontSize="0.65rem" flexShrink={0}>
                Proíbe atividades econômicas
              </Badge>
            )}
          </Flex>

          {uso.conteudo && (
            <TextGray fontSize="xs" mt="1" whiteSpace="pre-line">
              {uso.conteudo}
            </TextGray>
          )}
        </Box>
      ))}
    </Box>
  );
};
